import { visibleCanvas, noVisibleCanvas } from './utils'
import { findByPosition } from './node'
import { click, unclick, doubleclick } from './action'
import { tick } from './tick'

document.addEventListener('DOMContentLoaded', function () {
  if (noVisibleCanvas()) return
  // Hovering
  visibleCanvas().addEventListener('mousemove', e => {
    e.preventDefault()
    const node = findByPosition(e.layerX, e.layerY)
    if (node === undefined) {
      visibleCanvas().style.cursor = 'default'
    } else {
      if (node.highlightable === true || node.centerable === true || node.drillDownable === true) visibleCanvas().style.cursor = 'pointer'
      if (node.draggable === true) visibleCanvas().style.cursor = 'grab'
    }
  })

  // Tapping
  visibleCanvas().addEventListener('touchstart', e => {
    e.preventDefault()
    clickOrTap(e.touches[0].clientX, e.touches[0].clientY)
  })

  // Clicking
  visibleCanvas().addEventListener('mousedown', e => {
    e.preventDefault()
    clickOrTap(e.layerX, e.layerY)
  })

  // Doubleclicking
  visibleCanvas().addEventListener('dblclick', e => {
    e.preventDefault()
    doubleClickOrTap(e.layerX, e.layerY)
  })

  // Doubletapping
  let timeout
  let lastTap = 0
  const doubleClickTapLength = 350

  visibleCanvas().addEventListener('touchstart', e => {
    const currentTime = new Date().getTime()
    const tapLength = currentTime - lastTap

    e.preventDefault()
    clearTimeout(timeout)

    if (tapLength < doubleClickTapLength && tapLength > 0) {
      doubleClickOrTap(e.touches[0].clientX, e.touches[0].clientY)
    }
    lastTap = currentTime
  })

  // Disable pinch to zoom beyond visualization's limits
  visibleCanvas().addEventListener('wheel', e => {
    const { ctrlKey, metaKey } = event
    if (ctrlKey === true || metaKey === true) e.preventDefault()
  })
})

const clickOrTap = (x: number, y: number): void => {
  const node = findByPosition(x, y)
  if (node === undefined) {
    unclick()
    tick()
    return
  }
  click(node)
  tick()
}

const doubleClickOrTap = (x: number, y: number): void => {
  const node = findByPosition(x, y)
  if (node !== undefined) {
    doubleclick(node)
    tick()
  }
}
